module.exports = __webpack_public_path__ + "8df017a593b5f004e2ddb4e630e19c0e.MP3";